import { queryClient } from "@/config/react-query";

import { noteQueryKeys } from "./note-query";

export const invalidatePrefilledAnswers = () => {
  queryClient.invalidateQueries({
    queryKey: [...noteQueryKeys.all, "prefilled-answers"],
  });
};
